import theme from "./theme";
/** @type {import('tailwindcss').Config} */
export default {
  darkMode: ["class"],
  content: ["./src/**/*.{js,jsx,ts,tsx}"],
  whitelist: ["bg-slate-100"],
  theme: {
    extend: {
      fontFamily: {
        sans: ["Inter", "ui-sans-serif", "system-ui", "sans-serif"],
        mono: ["Roboto Mono", "monospace"],
      },
      colors: {
        input: "hsl(var(--input))",
        ring: "hsl(var(--ring))",
        background: "hsl(var(--background))",
        foreground: "hsl(var(--foreground))",
        divider: "var(--border)",
        border: {
          DEFAULT: "var(--border)",
          primary: "var(--border-primary)",
          dark: "var(--border-dark)",
          "primary-dark": "var(--primary-dark)",
          "dark-20": "var(--primary-border-dark-20)",
        },
        primary: {
          DEFAULT: "var(--primary)",
          background: "var(--primary-background)",
          foreground: "var(--primary-foreground)",
          border: "var(--primary-border)",
        },
        secondary: {
          DEFAULT: "var(--secondary)",
          foreground: "hsl(var(--secondary-foreground))",
        },
        destructive: {
          DEFAULT: "hsl(var(--destructive))",
          foreground: "hsl(var(--destructive-foreground))",
        },
        muted: {
          DEFAULT: "var(--muted)",
          foreground: "hsl(var(--muted-foreground))",
        },
        accent: {
          DEFAULT: "hsl(var(--accent))",
          foreground: "hsl(var(--accent-foreground))",
        },
        popover: {
          DEFAULT: "hsl(var(--popover))",
          foreground: "hsl(var(--popover-foreground))",
        },
        card: {
          DEFAULT: "hsl(var(--card))",
          foreground: "hsl(var(--card-foreground))",
        },
        // Use the warning definition from the second extend block:
        warning: "hsl(var(--warning))",
        // Spread in any additional colors from your imported theme:
        ...theme.colors,
        // Include the sidebar colors from the first extend block:
        sidebar: {
          DEFAULT: "hsl(var(--sidebar-background))",
          foreground: "hsl(var(--sidebar-foreground))",
          primary: "hsl(var(--sidebar-primary))",
          "primary-foreground": "hsl(var(--sidebar-primary-foreground))",
          accent: "hsl(var(--sidebar-accent))",
          "accent-foreground": "hsl(var(--sidebar-accent-foreground))",
          border: "hsl(var(--sidebar-border))",
          ring: "hsl(var(--sidebar-ring))",
        },
      },
      textColor: {
        primary: "var(--primary-text)",
        "primary-dark": "var(--primary-dark)",
        "primary-accent": "var(--primary)",
        secondary: "var(--secondary-text)",
        disabled: "var(--disabled-text)",
        label: "#4E5B6F",
        inverse: "var(--text-inverse)",
        "secondary-variant": "var(--secondary)",
        // Merged in from the second extend block:
        warning: "var(--warning-text)",
      },
      backgroundColor: {
        palette: {
          DEFAULT: "var(--background-default)",
          neutral: "var(--background-neutral)",
          inverse: "var(--background-inverse)",
        },
        contrast: "#F3F4F6",
        accent: "#F4F4F5",
        secondary: "var(--disabled-text)",
      },
      width: {
        25: "6.25rem",
        30: "7.5rem",
        98: "24.5rem",
      },
      boxShadow: {
        node: "0px 4px 14px -5px rgba(41, 45, 66, 0.1)",
        "toast-icon-green": "0px 0px 16px 0px #2FC362",
        "soft-sm": "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
        "light-sm": "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px",
      },
      spacing: {
        0.5: "0.125rem",
        1.5: "0.375rem",
        3.5: "0.875rem",
        4.5: "1.125rem",
        9.5: "2.375rem",
        18: "4.5rem",
        85: "21.25rem",
        90: "22.5rem",
        110: "27.5rem",
        160: "40rem",
        200: "50rem",
        250: "62.5rem",
      },
      keyframes: {
        "accordion-down": {
          from: {height: "0"},
          to: {height: "var(--radix-accordion-content-height)"},
        },
        "accordion-up": {
          from: {height: "var(--radix-accordion-content-height)"},
          to: {height: "0"},
        },
        "highlight-text": {
          "0%, 100%": {backgroundColor: "transparent"},
          "50%": {backgroundColor: "#fcd34d"},
        },
        pulseSize: {
          "0%, 100%": {transform: "scale(1)"},
          "50%": {transform: "scale(1.14)"},
        },
        redPulse: {
          "0%, 50%": {opacity: 0, transform: "scale(1)"}, // Stay hidden
          "70%": {opacity: 0.3, transform: "scale(1.3)"}, // Quick peak
          "100%": {opacity: 0, transform: "scale(1.6)"},
        },
      },
      animation: {
        "accordion-down": "accordion-down 0.2s ease-out",
        "accordion-up": "accordion-up 0.2s ease-out",
        "highlight-text": "highlight-text 0.5s ease-in-out 2",
        pulseSize: "pulseSize 1.2s infinite ease-in-out",
        redPulse: "redPulse 1.2s infinite ease-out",
      },
      opacity: {
        8: "0.08",
        10: "0.1",
        20: "0.2",
        12: "0.12",
        16: "0.16",
      },
      zIndex: {
        1000: "1000",
      },
    },
  },
  plugins: [require("tailwindcss-animate")],
};
